import React from 'react'

export type ServerErrorCode = 'NOT_FOUND' | 'FORBIDDEN' | 'UNKNOWN' | undefined | null

export const ServerErrorContext = React.createContext<ServerErrorCode>(null)

export const useServerErrorContext = () => React.useContext(ServerErrorContext)
